<template>
  <div id="stock-manager">
    <v-card
      :flat="flat"
      :class="{ 'transparent': flat }"
    >
      <v-container
        :pa-0="noPadding"
        fluid
        grid-list-xl
      >
        <v-row>
          <!-- Search field -->
          <v-col
            cols="12"
            md="4"
          >
            <v-subheader
              class="pl-0 d-block"
              style="height: auto"
            >
              Search for {{ stock_label }}
            </v-subheader>

            <v-row>
              <v-col>
                <v-autocomplete
                  v-model="stocksProxy"
                  :search-input.sync="searchInput"
                  :items="searchResults"
                  :loading="loading"
                  :hide-no-data="!searchInput || searchInput.length < 1 || loading"
                  :filter="matchall"
                  no-data-text="No such stock found"
                  return-object
                  :item-text="formatName"
                  item-value="id"
                  menu-props="offsetY"
                  multiple
                  outlined
                  dense
                  prepend-inner-icon="search"
                  append-icon=""
                  hide-details
                  class="pt-0"
                >
                  <template
                    slot="selection"
                  />
                </v-autocomplete>
              </v-col>
            </v-row>
            <!-- Filter filers -->
            <v-row v-if="mutualFund">
              <v-col>
                <v-select
                  v-model="filterInput"
                  :items="filtersItems"
                  menu-props="offsetY"
                  hide-details
                  outlined
                  dense
                  class="pt-0"
                  style="max-width: 225px"
                />
              </v-col>
            </v-row>
            <v-row >
              <v-col cols="12" sm="12" md="8">
                <v-text-field
                  v-model="ticker_list.list_text"
                  label="Tickers to Add"
                  outlined maxlength="100"
                  dense max="100"
                  hint="Add a list of tickers separated by commas or spaces (max 100 characters)"
                  persistent-hint
                />
              </v-col>
              <v-col cols="auto">
                <v-btn
                outlined
                  @click="import_list()"
                >
                  Add Tickers
                </v-btn>
              </v-col>
            </v-row>
          </v-col>

          <!-- Selected stocks list -->
          <v-col
            cols="12"
            md="8"
          >
            <v-row no-gutters>
              <v-col grow>
                <v-subheader
                  class="pl-0 d-block"
                  style="height: auto"
                >
                  Selected {{ stock_label }}
                  <span class="grey--text">({{ stocksProxy.length }})</span>
                </v-subheader>
              </v-col>
              <v-col class="shrink">
                <v-btn
                  v-if="stocksProxy.length"
                  text
                  color="error"
                  class="ma-0"
                  style="height: auto"
                  @click="clearSelection()"
                >
                  Clear
                </v-btn>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <span v-if="!stocksProxy.length">
                  {{ required ? 'You must select at least one stock.' : mutualFund ? 'No mutual fund(s)/ETF(s) selected.' : 'No stocks selected.' }}
                </span>

                <template v-else>
                  <v-chip
                    v-for="stock in stocksProxy"
                    :key="stock.id"
                    small
                    label
                    close
                    color="primary white--text"
                    class="ma-1"
                    @update:active="removeStockById(stock.id)"
                  >
                    {{ stock.ticker[0] }} {{ stock.name }}
                  </v-chip>
                </template>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
// Modules
import api from '@/store/api'

export default {
  props: {
    flat: Boolean,
    noPadding: Boolean,
    value: {
      type: Array,
      required: true
    },
    required: Boolean,
    mutualFund: Boolean
  },

  data: () => ({
    loading: false,
    stocksProxy: [],
    searchInput: null,
    searchResults: [],
    ticker_list:{list_text:''},
    filterInput: 0,
    filtersItems: [
      { text: 'Include Any', value: 0 },
      { text: 'Mutual Funds or ETFs', value: 1 },
      { text: 'ETF Only', value: 2 },
      { text: 'Mutual Fund Only', value: 3 }
    ]
  }),
  computed: {
    stock_label () {
      var label = 'Stocks'
      if (this.mutualFund) {
        label = 'Mutual Fund(s)/ETF(s)'
      }
      return label
    }
  },

  watch: {
    searchInput (val) {
      val && this.querySearch(val)
      this.searchInput = null
    },

    stocksProxy (stocksArray) {
      this.$emit('input', stocksArray)

        this.searchResults=[];
        this.searchInput=null;

      // this.$emit('update:stocks', stocksArray)
    }
  },

  created () {
    // this.stocksProxy = this.stocks
    this.stocksProxy = []
    for (var i = 0; i < this.value.length; i++) {
      this.stocksProxy.push(Object.assign({}, this.value[i]))
    }
    if (this.mutualFund) {
      this.filtersItems.splice(0, 1)
      this.filterInput = 1
    }
  },
  methods: {
    formatName (item) {
      if (!item || !item.ticker)
      { return '' }
      return item.ticker[0] + ' ' + item.name
    },
    matchall (val) {
      return true
    },
    import_list(){
      //send to server which will return array of matches, add to group up to limit, clear out list
      if (this.loading || this.ticker_list.list_text.trim().length==0 || this.ticker_list.list_text.trim().length>100){
        return;
      }
      this.loading = true
      const query = `ticker_lookup?tickers=${this.ticker_list.list_text}`
      api.get(query)
        .then(res => {
          var tickers=res.data;
          for (var i=0;i<tickers.length;i++){
            var s=tickers[i];
            this.stocksProxy.push({id:s.id,name:s.name,permalink:s.permalink,ticker:[s.symbol]})
          }


          this.ticker_list.list_text="";
        })
        .then(() => (this.loading = false))

    },
    querySearch (val) {
      this.loading = true
      const query = `stock_autocomplete?restrictions=${this.filterInput}&keyword=${val}`
      api.get(query)
        .then(res => {
          this.searchResults = res.data
        })
        .then(() => (this.loading = false))
    },

    removeStockById (id) {
      const index = this.stocksProxy.findIndex(stock => stock.id === id)
      this.stocksProxy.splice(index, 1)
    },

    clearSelection () {
      if (!window.confirm('Are you sure you want to clear your current stock selection?')) {
        return
      }

      this.stocksProxy = []
    }
  }
}
</script>
